import * as React from "react";
import * as ReactDOM from "react-dom";

const enterKeyCode = 13;

interface ChatMessageBoxProps {
  value: string;
  placeholder: string;
  onEnter: () => void;
  onChange: (text: string) => void;
}

class ChatMessageBox extends React.Component<ChatMessageBoxProps> {
  initialHeight = 0;
  _isMounted = true;

  componentDidMount() {
    const node = ReactDOM.findDOMNode(this) as HTMLTextAreaElement;
    const value = node.value;
    node.value = "F";
    this.resize();
    this.initialHeight = node.scrollHeight;
    node.value = value;
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: ChatMessageBoxProps) {
    if (prevProps.value !== this.props.value) {
      this.resize();
    }
  }

  onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === enterKeyCode && !e.shiftKey) {
      e.preventDefault();
      this.props.onEnter();
    }

    this.delayedResize();
  };

  onChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    this.props.onChange(e.currentTarget.value);
    this.resize();
  };

  delayedResize = () => {
    setTimeout(() => this.resize(), 0);
  };

  resize = () => {
    if (!this._isMounted) {
      return;
    }

    const node = ReactDOM.findDOMNode(this) as HTMLTextAreaElement;

    if (node && node.style) {
      const value = node.value;

      if (!value) {
        node.value = "F";
      }

      node.style.height = `${this.initialHeight}px`;
      node.style.height = `${node.scrollHeight}px`;
      node.value = value;
    }
  };

  render() {
    return (
      <textarea
        rows={1}
        placeholder={this.props.placeholder}
        value={this.props.value}
        onCut={this.delayedResize}
        onPaste={this.delayedResize}
        onDrop={this.delayedResize}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        aria-label="message"
      />
    );
  }
}

export default ChatMessageBox;
